import type { ColorScheme, OrganId } from "../types";

export const createUniformOrganColorSchemes = (
  organIds: readonly OrganId[],
  scheme: ColorScheme,
): Record<OrganId, ColorScheme> => {
  return organIds.reduce(
    (acc, organId) => {
      acc[organId] = scheme;
      return acc;
    },
    {} as Record<OrganId, ColorScheme>,
  );
};

export const createOrganOutlineSet = (
  organIds: readonly OrganId[],
  enabled: boolean,
): Set<OrganId> => {
  return enabled ? new Set(organIds) : new Set<OrganId>();
};
